import {
  DELETE_COURSE,
  GET_ACTIVE_COURSE,
  GET_AMOUNT_DURATION,
  GET_INFO_CHART,
  GET_NEXT_COURSE,
  GET_PAST_COURSE,
  GET_PENDING_COURSE,
  GET_SUBJECT,
  RESET_ACTIVE_COURSE,
  RESET_INFO_CHART,
  RESET_NEXT_COURSE,
  RESET_PAST_COURSE,
} from "../Actions/PunctualCourseActions";

const initialState: any = {
  activeCourse: [],
  pendingCourse: [],
  nextCourse: [],
  pastCourse: [],
  infoChart: [],
  amountAndDuration: [],
  subject: [],
};

const typeCourse = (courseType: string): string | undefined => {
  switch (courseType) {
    case GET_PAST_COURSE:
      return "pastCourse";
    case GET_ACTIVE_COURSE:
      return "activeCourse";
    case GET_PENDING_COURSE:
      return "pendingCourse";
    case GET_NEXT_COURSE:
      return "nextCourse";
    default:
      return undefined;
  }
};

// Reducer
export default function punctualCourseReducer(
  state = initialState,
  action: any,
): any {
  switch (action.type) {
    case GET_ACTIVE_COURSE:
      return { ...state, activeCourse: action.payload };
    case GET_PENDING_COURSE:
      return { ...state, pendingCourse: action.payload };
    case GET_NEXT_COURSE:
      return { ...state, nextCourse: action.payload };
    case GET_PAST_COURSE:
      return { ...state, pastCourse: action.payload };
    case GET_INFO_CHART:
      return { ...state, infoChart: action.payload };
    case GET_AMOUNT_DURATION:
      return { ...state, amountAndDuration: action.payload };
    case GET_SUBJECT:
      return { ...state, subject: action.payload };
    case DELETE_COURSE: {
      // payload: { id: number, courseType: GET_NEXT_COURSE | GET_ACTIVE_COURSE | ... }
      const stateKey = typeCourse(action.payload?.courseType);
      if (!stateKey) return state;

      if (stateKey === "nextCourse" || stateKey === "activeCourse") {
        // Grouped structure: courses[] → { clientId, courses: [{ id, ... }] }
        const updatedGroups = (state[stateKey]?.courses ?? [])
          .map((group: any) => {
            if (group.clientId !== action.payload?.clientId) return group;
            return {
              ...group,
              courses: (group.courses ?? []).filter(
                (c: any) => c.id !== action.payload?.id,
              ),
            };
          })
          .filter((group: any) => group.courses.length > 0);
        return {
          ...state,
          [stateKey]: { ...state[stateKey], courses: updatedGroups },
        };
      }

      // Flat structure for pastCourse / pendingCourse
      return {
        ...state,
        [stateKey]: {
          ...state[stateKey],
          courses: (state[stateKey]?.courses ?? []).filter(
            (post: any) => post.id !== action.payload?.id,
          ),
        },
      };
    }
    case RESET_ACTIVE_COURSE:
      return null;
    case RESET_PAST_COURSE:
      return null;
    case RESET_INFO_CHART:
      return null;
    case RESET_NEXT_COURSE:
      return null;

    default:
      return state;
  }
}
